module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS5.8f3474b9.jpg";